import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles(() =>
  createStyles({
    resultsPanel: {
      flex: 1,
    },
  }),
);

export default useStyles;
